import {convertCssAniDurationToMS, addClassForCloseAnimation} from "../utilities/helper-function";
import {getFocusableElements, trapFocus} from "../helpers/helper";

class Overlay {
    constructor(element) {
        this.body = document.querySelector('body');
        this.overlayWrapper = element;
        this.overlay = this.overlayWrapper.querySelector('.overlay__inner');
        if (!this.overlay) return;
        this.overlayId = this.overlay.id;
        this.isMobileOnlyOverlay = this.overlayWrapper.classList.contains('overlay--mobile-only');
        this.focusableElements = getFocusableElements(this.overlay);
        this.focusableElementsLength = this.focusableElements.length;

        this.triggerBtn = document.querySelector(`button[data-target-id="${this.overlayId}"]`);
        this.closeBtn = this.overlay.querySelector('button[data-target="overlay"][data-overlay-action="close"]');

        this.rootStyles = getComputedStyle(document.documentElement);
        this.aniFast = convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--fast').trim());
        this.aniSlow = convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--slow').trim());

        this.mobileBreakpoint = 768;
        this.isResizeToTabletEventCalled = false;
        this.lastWindowSize = 0;

        if (this.triggerBtn) {
            this.triggerBtn.addEventListener('click', () => {
                this.openOverlay();
            })
        }

        this.closeBtn.addEventListener('click', () => {
            this.closeOverlay();
        })

        if (this.isMobileOnlyOverlay) {
            window.addEventListener('resize', () => {
                if (!this.isOverlayOpened()) return;
                this.updatePanelLayerVisibilityByResize();
                this.lastWindowSize = window.innerWidth === 0 ? 0 : window.innerWidth
            })
        }

        if (window.innerWidth >= this.mobileBreakpoint) {
            window.addEventListener('click', (e) => {
                if (!this.isOverlayOpened()) return;
                if (e.target === this.overlayWrapper) {
                    this.closeOverlay();
                }
            })
        }

        document.addEventListener('keydown', (e) => {
            if (!this.isOverlayOpened()) return;
            trapFocus(e, () => this.focusableElements);

            if (e.key === "Escape") {
                e.preventDefault();
                this.closeOverlay();
            }
        })
    }

    closeOverlay() {
        this.overlayWrapper.classList.remove("overlay--open");
        this.body.classList.remove('body--not-scrollable');
        addClassForCloseAnimation(this.overlayWrapper, "overlay--close", this.aniFast)
    }

    openOverlay() {
        if (this.isMobileOnlyOverlay) {
            if (window.innerWidth >= this.mobileBreakpoint) return;
        }
        this.overlayWrapper.classList.add('overlay--open');
        this.body.classList.add('body--not-scrollable');
        this.focusableElements = getFocusableElements(this.overlay);
    }

    updatePanelLayerVisibilityByResize() {
        // Resize window to larger
        if (window.innerWidth > this.lastWindowSize) {
            // Window Size is larger than Mobile
            if (window.innerWidth >= this.mobileBreakpoint) {
                // Call only once when the window size becomes bigger than
                // mobile breakpoint
                if (!this.isResizeToTabletEventCalled) {
                    if (this.overlayWrapper) {
                        this.overlayWrapper.classList.remove('overlay--open');
                    }
                    this.isResizeToTabletEventCalled = true;
                }
            }
        } else {
            if (window.innerWidth < this.mobileBreakpoint) {
                if (this.isResizeToTabletEventCalled) {
                    this.isResizeToTabletEventCalled = false;
                }
            }
        }
    }

    isOverlayOpened() {
        return this.overlayWrapper.classList.contains('overlay--open');
    }
}

export default Overlay;